import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { Perfil } from '../models/perfil';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PerfilService } from '../services/perfil.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-perfil-acesso',
  templateUrl: './perfil-acesso.component.html',
  styleUrls: ['./perfil-acesso.component.scss']
})
export class PerfilAcessoComponent implements OnInit, OnDestroy {

  // variáveis
  perfisFiltrados: Perfil[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private perfilService: PerfilService, private utilitarioService: UtilitarioService,
    private router: Router, private paginatorService: PaginatorService, private route: ActivatedRoute,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPerfis();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPerfis();
    this.paginator.firstPage();
  }

  buscarPerfis() {
    this.carregandoService.mostra('buscaPerfis');
    this.carregando = true;

    this.perfilService.consultarPerfisComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
      this.perfisFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaPerfis');
    }, (erro) => {
      this.carregandoService.esconde('buscaPerfis');
      this.notificacaoService.erro(erro);
    });
  }

  novoPerfil() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarPerfil(perfil) {
    this.router.navigate(['editar', perfil.id], { relativeTo: this.route });
  }

  excluirPerfil(perfil: Perfil) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Permissão?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiPerfil');
        this.perfilService.excluir(perfil.id).subscribe(resp => {
          this.notificacaoService.sucesso('Permissão excluída com sucesso!!!');
          this.carregandoService.esconde('excluiPerfil');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiPerfil');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPerfis();
  }

  ngOnDestroy(): void {}
}
